import { render, staticRenderFns } from "./LegacyTestForm.vue?vue&type=template&id=cd6ea4fe&scoped=true"
import script from "./LegacyTestForm.vue?vue&type=script&lang=js"
export * from "./LegacyTestForm.vue?vue&type=script&lang=js"
import style0 from "./LegacyTestForm.vue?vue&type=style&index=0&id=cd6ea4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6ea4fe",
  null
  
)

export default component.exports